import * as React from 'react';
import { Tabs } from '@cian/ui-kit/prev';

import { TransportAccessibilitySidebar } from '../../../../components/Map/parts/TransportAccessibility';
import { ETransportAccessibilityTab, TTAInfrastructureType } from '../../../../types/map';
import { TransportAccessibilityInside } from '../TransportAccessibilityInside';
import { TransportAccessibilityOutside } from '../TransportAccessibilityOutside';
import { useTransportAccessibilityTabs } from './hooks';
import { trackTabChange } from '../../analytics';

export interface ITransportAccessibilitySidebarContainerProps {
  onClose: () => void;
  onTransportAccessibilityChange: (infrastructureType: TTAInfrastructureType | null) => void;
}

export const TransportAccessibilitySidebarContainer: React.FC<ITransportAccessibilitySidebarContainerProps> = ({
  onClose,
  onTransportAccessibilityChange,
}) => {
  const tabs = useTransportAccessibilityTabs();
  const [activeTab, setActiveTab] = React.useState<string>(tabs[0].value);

  const hasVisibileTabs = tabs.length > 1;

  const changeTab = React.useCallback((tab: string) => {
    setActiveTab(tab);
    trackTabChange(tab);
  }, []);

  return (
    <TransportAccessibilitySidebar
      onClose={onClose}
      tabs={hasVisibileTabs && <Tabs activeTab={activeTab} onChange={changeTab} tabs={tabs} />}
    >
      {activeTab === ETransportAccessibilityTab.Outside && (
        <TransportAccessibilityOutside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
      {activeTab === ETransportAccessibilityTab.Inside && (
        <TransportAccessibilityInside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
    </TransportAccessibilitySidebar>
  );
};
